import { ProfileImageMedia } from "@client/content/controls/Media/component";
import { PageLink } from "@client/controls/Link/container";
import { type I18n } from "@client/types";
import appInfo from "@common/appInfo";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";

export const INVISIBLE_PROPS: UserProps = {
  canRegister: false,

  profilePageId: "",
  registerPageId: ""
};

export interface UserProps {
  canRegister: boolean;

  profilePageId: string;
  registerPageId: string;
}

const renderRegister = (i18n: I18n, props: UserProps) => {
  if (appInfo.user) {
    return (
      <>
        <PageLink title={i18n.profile} className="list-entry" rel="nofollow" pageId={props.profilePageId}>
          {i18n.profile}
        </PageLink>
        <ProfileImageMedia
          displayName={appInfo.user.displayName}
          email={appInfo.user.email}
          sourceId={appInfo.user.profilePictureMediaSourceId}
          sourceKey="AwsS3"
          size={32}
        />
      </>
    );
  }

  if (props.canRegister) {
    return (
      <PageLink title={i18n.register} className="list-entry" rel="nofollow" pageId={props.registerPageId}>
        {i18n.register}
      </PageLink>
    );
  }

  return null;
};

export const User = (props: UserProps) => {
  const i18n = useI18n();

  return <div className="wsc_user_info">{renderRegister(i18n, props)}</div>;
};

export default User;
